// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3383":"92cdb89de440c481","9410":"57dd4e08120f97ef"}[chunkId] + ".js";
};